import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Funcoes } from '@/features/funcoes/componentes/Funcoes';
import { rotaDeTela } from '@/features/permissoes/guardas';

const busca = z.object({
  busca: z.string().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
  tags: z.string().optional().catch(undefined),
  excluidas: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_autenticado/equipe/funcoes/')({
  ...rotaDeTela('equipe.funcoes'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { busca: texto, cursor, excluidas, tags } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Funcoes
      filtros={{ busca: texto, cursor, incluirExcluidas: excluidas, tags }}
      aoMudarFiltros={({ busca: novaBusca, cursor: novoCursor, incluirExcluidas, tags: novas }) => {
        void navigate({
          search: {
            busca: novaBusca,
            cursor: novoCursor,
            excluidas: incluirExcluidas,
            tags: novas,
          },
          replace: true,
        });
      }}
    />
  );
}
